export const ENDPOINTS = {
  getReviews: '/gateway/extranet/:id/reviews',
  getReviewsByPack: '/gateway/extranet/:id/reviews/packs',
} as const;

export const CORE_QUERY_KEYS = {
  reviews: 'extranet-reviews',
  reviewsByPack: 'extranet-reviews-packs',
} as const;
